// DS: i1.6
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Gift: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13 2l-2-1H9.5L8 2.5 6.5 1H5c.043 0-2 1-2 1l3.077 2H1.625A.625.625 0 001 4.625v1.75c0 .345.28.625.625.625H2v2h5.5V5h1v4H14v1H8.5v4h-1v-4H2v3.375c0 .345.28.625.625.625h10.75c.345 0 .625-.28.625-.625V7h.375c.345 0 .625-.28.625-.625v-1.75A.625.625 0 0014.375 4h-4.46L13 2z"
        clipRule="evenodd"
      ></path>
    </svg>
  </IconWrap>
);
Gift.displayName = 'Gift';

export default Gift;
